import { constructPublicRoute } from '~/core/shared/utils/routing';

export const MIDDLE_OFFICE_LOGIN_BASE_URL = '/login';
export const MIDDLE_OFFICE_RESET_BASE_URL = '/reset-password';

export const MIDDLE_OFFICE_AUTH_ROUTES = {
  login: constructPublicRoute(MIDDLE_OFFICE_LOGIN_BASE_URL, 'Login'),
  loginVerifyCode: constructPublicRoute(
    `${MIDDLE_OFFICE_LOGIN_BASE_URL}/verify-code`,
    'Verify code',
  ),

  resetPasswordEnterEmail: constructPublicRoute(
    MIDDLE_OFFICE_RESET_BASE_URL,
    'Reset password',
  ),
  resetPasswordCheckEmail: constructPublicRoute(
    `${MIDDLE_OFFICE_RESET_BASE_URL}/sent`,
    'Check your email',
  ),
  resetPasswordSetNewPassword: constructPublicRoute(
    `${MIDDLE_OFFICE_RESET_BASE_URL}/set-new-password`,
    'Set new password',
  ),
  resetPasswordUpdated: constructPublicRoute(
    `${MIDDLE_OFFICE_RESET_BASE_URL}/password-updated`,
    'Password updated',
  ),
} as const;
